import { Button, Dialog, InputAdornment, Stack, TextField, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useRef } from 'react';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import ModalHeader from '../../../../components/ModalHeader';
import { Form, Formik } from 'formik';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import FormTextField from '../../../../components/FormTextField';
import moment from 'moment';
import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import appapi from '../../../../api/apiClient';
import uploadFileToS3 from '../../../../utils/fileUpload';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

const validationSchema = yup.object({
  price: yup.number('price').required(' '),
  transactionId: yup.string('Transaction Id').required().min(3, 'Transaction Id should be atleast 3 character').max(20, 'Maximum Character Limit 20').required(' '),
  receiptAttachment: yup.string().required(),
  transactionDate: yup.date().required(),
  totalAmount: yup.number().required(),
  deliveryDate: yup.date().required(),
  remarks: yup.string('Remarks').required(' ').min(3, 'Remarks should be atleast 3 character').max(300, 'Maximum Character Limit 300').required(' '),
});

export default function ProcessQuote({ modelOpen, onModelHandleClose, data }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { user, companyDetails } = useSelector((state) => state.auth);
  const { t } = useTranslation();

  const handleFile = (file) => {
    if (file?.path) {
      formRef?.current?.setFieldValue('receiptAttachment', file);
    } else {
      formRef?.current?.setFieldValue('receiptAttachment', undefined);
    }
  };

  const handleProcessQuote = async (values) => {
    dispatch(setLoading(true));
    if (values.receiptAttachment && values.receiptAttachment?.path) {
      try {
        values['receiptAttachment'] = await uploadFileToS3(values.receiptAttachment);
      } catch (e) {}
    }
    const response = await appapi.put(`/trader/processQuote/${data?._id}`, values);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
        flex={1}
      >
        <ModalHeader
          label={t('PROCESS QUOTE')}
          onClose={() => onModelHandleClose(false)}
        />

        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            price: data?.price ? data?.price : undefined,
            transactionId: '',
            receiptAttachment: undefined,
            transactionDate: null,
            totalAmount: '',
            deliveryDate: null,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleProcessQuote(values);
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue, setFieldTouched }) => (
            <Form
              className="flex flex-col flex-1"
              autoComplete="off"
            >
              <Stack className="px-4 !mt-[16px]">
                <FileUploadField
                  placeholder={t('Upload File (CSV, XLSX, PDF)')}
                  url={values?.receiptAttachment ? values?.receiptAttachment : null}
                  inputId={`doc`}
                  handleFile={(files) => handleFile(files)}
                  showFileName={false}
                  bgColor={'#f3f4f7'}
                  enableExcel={true}
                />
              </Stack>

              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Details')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack
                  direction={'row'}
                  className="!mb-[16px]"
                >
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular"
                      color={text}
                    >
                      {t('ID')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                      style={{ maxWidth: '225px' }}
                    >
                      {data?.id}
                    </Typography>
                  </Stack>
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular"
                      color={text}
                    >
                      {t('Timestamp')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                    >
                      {moment(data?.createdOn).format('DD-MMM-YYYY HH:mm')}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack
                  direction={'row'}
                  className="!mb-[16px]"
                >
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular"
                      color={text}
                    >
                      {t('Client')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                      style={{ maxWidth: '225px' }}
                    >
                      {data?.companyName}
                    </Typography>
                  </Stack>
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular"
                      color={text}
                    >
                      EUA
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                    >
                      {data?.euaRequired}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack
                  direction={'row'}
                  className="!mb-[16px]"
                >
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular !capitalize"
                      color={text}
                    >
                      {t('Display name')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                      style={{ maxWidth: '225px' }}
                    >
                      {data?.displayName}
                    </Typography>
                  </Stack>
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular"
                      color={text}
                    >
                      {t('Price / EUA')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                    >
                      € {data?.price}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack
                  direction={'row'}
                  className="!mb-[16px]"
                >
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular"
                      color={text}
                    >
                      {t('Type')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium capitalize"
                      color={text}
                      style={{ maxWidth: '225px' }}
                    >
                      {data?.priceType}/{data?.tradeType}
                    </Typography>
                  </Stack>
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw- !capitalize"
                      color={text}
                    >
                      {t('Total amount')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                    >
                      {(data?.totalAmount && '€' + data?.totalAmount?.toFixed(2)) || 'NA'}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack
                  direction={'row'}
                  className="!mb-[16px]"
                >
                  <Stack flex={0.5}>
                    <Typography
                      className="fs-12 ff-Roboto fw-regular !capitalize"
                      color={text}
                    >
                      {t('Delivery date')}
                    </Typography>
                    <Typography
                      className="fs-14 ff-Roboto fw-medium"
                      color={text}
                      style={{ maxWidth: '225px' }}
                    >
                      {data?.deliveryDate || '-'}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Transaction Details')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                  {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Transaction ID')}
                    name="transactionId"
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 21 }}
                  />
                </Stack>
                <Stack className="mb-[20px] ">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label={t('Transaction date') + ' *'}
                      // disablePast
                      timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                      value={values.transactionDate}
                      onChange={(newValue) => setFieldValue('transactionDate', newValue)}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(event) => {
                            event.preventDefault();
                          }}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
                <Stack className="mb-[20px] ">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={t('Delivery date') + ' *'}
                      // disablePast

                      value={values.deliveryDate}
                      onChange={(newValue) => setFieldValue('deliveryDate', newValue)}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(event) => {
                            event.preventDefault();
                          }}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Price / EUA')}
                    name="price"
                    onlyFloat={true}
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 10 }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                    }}
                    disabled={true}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Total amount')}
                    name="totalAmount"
                    onlyFloat={true}
                    requiredMark={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 10 }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                    }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Remark')}
                    name="remarks"
                    multiline={true}
                    maxRows={3}
                    requiredMark={true}
                    inputProps={{ maxLength: 300 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        minHeight: '88px !important',
                        display: 'block',
                      },
                    }}
                  />
                </Stack>
              </Stack>
              <Stack flexGrow={1} />

              <Stack
                // direction="row"
                justifyContent="flex-end"
                className="px-4 py-4 !justify-end p-[0px] sticky bottom-[0] !mt-[32px]"
                // className="!mt-[44px] h-[66px] "
                style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
              >
                {' '}
                <Typography style={{ color: 'red', alignSelf: 'center' }}>Disclaimer: Once submitted, transaction details cannot be altered.</Typography>
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  className="!justify-end !mt-[10px]"
                >
                  <Button
                    sx={[
                      dialogButtonCancel,
                      {
                        color: theme.palette.primary.main,
                        '&:hover': {
                          // backgroundColor: theme.palette.secondary.main,
                          // color: theme.palette.background.main,
                          // borderColor: theme.palette.secondary.main,
                        },
                      },
                    ]}
                    style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                    onClick={() => {
                      onModelHandleClose(false);
                    }}
                  >
                    {t('Close')}
                  </Button>
                  <Button
                    sx={[
                      buttonStyle2,
                      {
                        color: '#fff',
                        backgroundColor: theme.palette.primary.main,
                        textTransform: 'uppercase',
                        '&:hover': {
                          backgroundColor: theme.palette.background.main,
                          color: '#fff',
                        },
                        '&:disabled': {
                          color: 'rgba(255,255,255,0.5)',
                          backgroundColor: theme.palette.primary.main,
                        },
                      },
                    ]}
                    style={{ width: '128px', height: '40px' }}
                    disabled={!(dirty && isValid)}
                    type="submit"
                    variant="contained"
                  >
                    {t('Save')}
                  </Button>
                </Stack>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
